/**
 * Demande de création de site en mode démonstration : aucune demande au
 * départ, le formulaire s'envoie et la demande devient « en cours », en
 * mémoire. Une seconde demande est refusée comme le fait l'API (`409`).
 */
import { ApiError } from './errors.js';
import type { CorpsDemandeSite, DemandeSiteVue } from './demandeSite.js';

let demandes: DemandeSiteVue[] = [];

const ouverte = (): DemandeSiteVue | null =>
  demandes.find(({ etat }) => etat === 'envoyee' || etat === 'en_cours') ?? null;

export function reponseDemoDemandeSite(methode: string, corps?: unknown): unknown {
  if (methode === 'GET') {
    return { demandes: structuredClone(demandes), enCours: structuredClone(ouverte()) };
  }
  if (methode === 'POST') {
    if (ouverte()) {
      throw new ApiError(409, 'conflit.version', 'Une demande est déjà ouverte.', {
        raison: 'demande_site_en_cours',
      });
    }
    const envoi = corps as CorpsDemandeSite;
    const demande: DemandeSiteVue = {
      id: `demo-demande-site-${String(demandes.length + 1)}`,
      etat: 'envoyee',
      siteExistant: envoi.siteExistant,
      urlActuelle: envoi.siteExistant ? envoi.urlActuelle : null,
      objectifs: envoi.objectifs,
      langues: envoi.langues,
      visiteVirtuelle: envoi.visiteVirtuelle,
      delai: envoi.delai,
      budget: envoi.budget ?? null,
      message: envoi.message ?? '',
      contact: {
        nom: envoi.contact.nom,
        email: envoi.contact.email,
        telephone: envoi.contact.telephone ?? null,
        moyen: envoi.contact.moyen,
      },
      envoyeeLe: new Date().toISOString(),
      traiteeLe: null,
    };
    demandes = [demande, ...demandes];
    return { demande: structuredClone(demande) };
  }
  return undefined;
}
